module.exports = __webpack_public_path__ + "img/img-question-2-collaboration-in-class-with-tablet.311f5b12.jpg";